// extracted by mini-css-extract-plugin
export default {"summary":"order-summary_summary__JT2vH"};